import { WiziQuestionList } from './WiziQuestionList';
import { WiziQuestionCreate } from './WiziQuestionCreate';
import { WiziQuestionEdit } from './WiziQuestionEdit';

export default {
    list: WiziQuestionList,
    create: WiziQuestionCreate,
    edit: WiziQuestionEdit,
};
